import React from 'react';
export const Upload = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.55567 7.71597L8.99934 2.84956L13.5427 7.71597M9 2.84956V23M17 1H1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
